module.exports = __webpack_public_path__ + "img/location-category-online@2x.30cfde3.webp";